/* eslint-disable react-hooks/rules-of-hooks */
import { graphql, useStaticQuery } from "gatsby"
import { useMergePrismicPreviewData } from "gatsby-plugin-prismic-previews"

export const allContributors = () => {
  const staticData = useStaticQuery(
    graphql`
      query AllContributors {
        allPrismicContributor(
          filter: {
            uid: { ne: "foodscape-pages" }
            data: { is_core_team_member: { ne: true } }
          }
          sort: { fields: [data___name], order: [ASC] }
        ) {
          edges {
            node {
              ...ContributorBase
              ...ContributorMediumProfilePic
            }
          }
        }
      }
    `
  )

  const { data } = useMergePrismicPreviewData(staticData)
  return data.allPrismicContributor.edges.map(edge => edge.node)
}
